import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconNews = createIcon({
  displayName: 'IconNews',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M19 18V7H21V18C21 19.65 19.65 21 18 21C16.35 21 15 19.65 15 18V5H5V16C5 17.65 6.35 19 8 19H13.1C13.25 19.73 13.57 20.39 14 20.97V21H8C5.24 21 3 18.76 3 16V3H17V18C17 18.55 17.45 19 18 19C18.55 19 19 18.55 19 18ZM7 7H13V9H7V7ZM7 11H13V13H7V11ZM13 15H7V17H13V15Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
